module.exports = __webpack_public_path__ + "img/apple-logo.59ae0573.png";